/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';

@Component({
  standalone: true,
  imports: SIMPLE_PAGE_IMPORTS,
  selector: 'adn-release-notes-edit-title',
  template: `
    <div class="breadcrumbContainer">
      <a uiSref="app.simple.release-notes">Back to release notes list</a>
    </div>
    <adn-state-title></adn-state-title>
  `
})
export class ReleaseNotesEditTitleComponent {
}
